import React, { useState, useEffect } from "react";
import { Container, Typography, Button, Box } from "@mui/material";
import api from "../../api/api";
import { useNavigate, useParams } from "react-router-dom";
import TableConfigList from "./TableConfigList";
import ActionConfigList from "./ActionConfigList"; // Импортируем новый компонент
import AccordionSection from "./AccordionSection"; // Аккордеоны для разделов

function BusinessSettings() {
  const { id } = useParams(); // Получаем ID бизнеса из URL
  const navigate = useNavigate(); // Для перехода назад
  const [business, setBusiness] = useState(null);
  const [tableConfigs, setTableConfigs] = useState([]);
  const [actionConfigs, setActionConfigs] = useState([]); // Для экшенов
  const [modules, setModules] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadBusinessDetails();
    loadTableConfigs();
    loadActionConfigs(); // Загружаем экшены
  }, []);

  // Загрузка информации о бизнесе
  const loadBusinessDetails = async () => {
    try {
      const response = await api.get(`/admin/business-types/${id}`);
      setBusiness(response.data);
    } catch (error) {
      console.error("Ошибка загрузки данных бизнеса:", error);
    }
  };

  // Загрузка конфигурации таблиц
  const loadTableConfigs = async () => {
    try {
      const response = await api.get(`/table-configs/?business_type_id=${id}`);

      setTableConfigs(response.data);

      const generatedModules = generateModulesFromConfigs(response.data);
      setModules(generatedModules);
    } catch (error) {
    } finally {
    }
  };

  const loadActionConfigs = async () => {
    console.log("Начинаем загрузку экшенов для бизнеса с ID:", id);

    try {
      const response = await api.get(`/actions/actions-by-id`, {
        params: { businessTypeId: id },
      });
      console.log("Загруженные экшены:", response.data);
      setActionConfigs(response.data);
    } catch (error) {
      console.error("Ошибка загрузки экшенов:", error);
    } finally {
      setIsLoading(false); // Обязательно сбрасываем состояние
    }
  };

  // Генерация модулей из конфигурации таблиц
  const generateModulesFromConfigs = (configs) => {
    const modulesObj = {};
    configs.forEach((config) => {
      modulesObj[config.config_data.column_name] = true; // Отображение по умолчанию
    });
    return modulesObj;
  };

  // Обновление модулей
  const handleModulesUpdate = (updatedModules) => {
    console.log("Обновленные модули:", updatedModules);
    setModules(updatedModules);
  };

  // Обновление экшенов
  const handleActionsUpdate = (updatedActions) => {
    console.log("Обновленные экшены:", updatedActions);
    setActionConfigs(updatedActions);
  };

  // Сохранение изменений
  const saveChanges = async () => {
    try {
      const selectedModules = Object.keys(modules).filter(
        (key) => modules[key]
      );

      const payload = {
        modules: selectedModules,
      };

      console.log("Сохраняем данные:", payload);

      // Сохранение модулей в таблице конфигураций
      await api.put(`/admin/business-types/${id}`, payload);

      alert("Изменения успешно сохранены!");
      navigate("/admin-panel"); // Возврат в админ-панель
    } catch (error) {
      console.error("Ошибка сохранения изменений:", error);
      alert("Ошибка при сохранении данных.");
    }
  };

  if (isLoading) {
    return <Typography>Загрузка...</Typography>;
  }

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Настройки бизнеса: {business?.name}
      </Typography>

      {/* Конфигурация колонок */}
      <AccordionSection title="Конфигурация колонок">
        <TableConfigList
          businessTypeId={id}
          onModulesUpdate={handleModulesUpdate}
        />
      </AccordionSection>

      {/* Конфигурация экшенов */}
      <AccordionSection title="Конфигурация экшенов">
        <ActionConfigList
          actionConfigs={actionConfigs}
          onActionsUpdate={handleActionsUpdate}
          businessTypeId={id} // ID текущего типа бизнеса из URL или состояния
        />
      </AccordionSection>

      {/* Кнопки сохранения и выхода */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={saveChanges}
          sx={{ mr: 2 }}
        >
          Сохранить
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => navigate("/admin-panel")}
        >
          Выйти
        </Button>
      </Box>
    </Container>
  );
}

export default BusinessSettings;
